import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { empty } from 'rxjs/Observer';
import { TokenStorage } from '../../../storages/token.storage';
import { MessageWithTextPopup } from '../../modal-window/message-with-text-popup/message-with-text-popup.component';


const apiServer = environment.apiServer;


@Injectable()
export class FileImportExportService {
  spinner: NgxSpinnerService;
  http: HttpClient;
  apiControl: string;
  downloadFileName: string;
  dataSetExportImportTable: any;
  token: TokenStorage;
  messageWithTextPopup: MessageWithTextPopup;

  constructor(_token: TokenStorage) { 
    this.token = _token;
    this.messageWithTextPopup = new MessageWithTextPopup()
  }

  onImport(event) {
    let fileToUpload: File = null;
    const onImportField = $('#onImportField');
    const selectedValueComponent = $('#selectedValueList');

    this.spinner.show();
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      fileToUpload = fileList[0];

      const endpoint = apiServer + this.apiControl + "/import";
      const formData: FormData = new FormData();
      formData.append('fileKey', fileToUpload, fileToUpload.name);

      const myHeaders = new HttpHeaders().set('Access-Control-Allow-Origin', 'origin-list');

      try {
        return new Promise(resolve => {
          this.http.put<any>(endpoint, formData, { headers: myHeaders }).subscribe(resp => {
            this.spinner.hide();
            if(resp == empty || resp == null){
              $('#downloadErrorModal').show();
              return new Promise(() => {}).catch(() => {});
            } else if(resp.message != empty && resp.message != null) {
              this.messageWithTextPopup.show('Выполнено', resp.message)
            }
            

            this.dataSetExportImportTable = resp.data;
            this.dataSetExportImportTable.recordsTotal = resp.recordsTotal,
              this.dataSetExportImportTable.recordsFiltered = resp.recordsFiltered,
            selectedValueComponent.val('');
            onImportField.val('');
            resolve(this.dataSetExportImportTable);
          });
        });
      } catch (e) {
        $('#downloadErrorModal').show();
        this.spinner.hide();
        onImportField.val('');
      }
    } else {
      $('#downloadErrorModal').show();
      this.spinner.hide();
      onImportField.val('');
      return new Promise(() => {}).catch(() => {});
    }
  }

  fileExportExample(event) {
    this.spinner.show();
    const endpoint = apiServer + this.apiControl + "/exportExample";
    try {
        this.http.get(endpoint, {
          responseType: 'arraybuffer'
        }
        ).subscribe(resp => {
          this.downLoadFile(resp, "application/ms-excel")
          this.spinner.hide();
        });
    } catch (e) {
      this.spinner.hide();
    }
  }

  public fileExport() {
    this.spinner.show();
    const endpoint = apiServer + this.apiControl + "/export";
    try {
      this.http.get(endpoint, {
        responseType: 'arraybuffer'
      }
      ).subscribe(resp => {
        this.downLoadFile(resp, "application/ms-excel")
        this.spinner.hide();
      });
    } catch (e) {
      this.spinner.hide();
    }
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);

    var anchor = document.createElement("a");
    anchor.download = this.downloadFileName;
    anchor.href = url;
    anchor.click();
  }

  updateVisibilytyFieldFromeRole() {
    let person = this.token.getRole();

    $('#fileExportButton').hide();
    $('#fileImportButton').hide();
    if (person.includes("administrator")) {
      $('#fileExportButton').show();
      $('#fileImportButton').show();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/service/file-import-export.service.ts